import React from 'react';

import {
  SelectedEntities,
} from '../../../components';
import { APP_OPTIONS } from '../../../config/constants';

const ParagraphSelectedProjects = ({ id, entity }) => {

  return (
    <SelectedEntities
      id={id}
      type="projects"
      link={APP_OPTIONS.parameters.links.viewAllProjects}
      entities={entity.getIn(['field_selected_projects'])}
      title={entity.getIn(['field_title', 0, 'value'])}
    />
  );
};

export default ParagraphSelectedProjects;
